import { IconCollection } from "components/Icon/IconCollection";
import IconButton from "components/IconButton";
import Tooltip from "components/Tooltip/Tooltip";

export interface LiveUpdatesIconProps {
    isLiveUpdatesEnabled: boolean;
    setLiveUpdatesEnabled: (isLiveUpdatesEnabled: boolean) => void;
}

export const LiveUpdatesIcon = ({
    isLiveUpdatesEnabled,
    setLiveUpdatesEnabled,
}: LiveUpdatesIconProps) => (
    <div style={{ width: "30px" }}>
        <Tooltip overlay="Live update">
            <IconButton
                onClick={() => setLiveUpdatesEnabled(!isLiveUpdatesEnabled)}
                icon={
                    isLiveUpdatesEnabled
                        ? IconCollection.accessPoint
                        : IconCollection.accessPointOff
                }
            />
        </Tooltip>
    </div>
);
